import React from 'react'
import img from '../../Images/Group 427319854 (1).png'
const BusinessCardBenefits = () => {
    return (
        <>
            <div className='business_card_benefits_wrapper'>
                <div className='what_neo_business_content'>
                    <h6>Digital business card’s benefits</h6>
                    <h5>Make a lasting impact with a digital business card showcasing your brand's
                        essential information, including contact information, social profiles, web links,
                        and additional details. Through clean design, easy sharing, analytics,
                        contact management, and more, Neoo Search helps maximise opportunities
                        and
                        understanding
                        in your professional engagements.</h5>
                </div>
             <div className='business_card_benfits_img'>
                <img src={img}/>
             </div>
            </div>
        </>
    )
}

export default BusinessCardBenefits